const STYLE_ID = 'cvt-card-gallery-modal-styles';
function ensureModalPortalStyles(cssText) {
    if (typeof document === 'undefined') {
        return;
    }
    const existing = document.getElementById(STYLE_ID);
    if (existing) {
        return;
    }
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = cssText;
    document.head.appendChild(style);
}

export { ensureModalPortalStyles };
